/*
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.header-sidebar__linklist-button-child');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      console.log("aaaa");
      const targetUl = this.nextElementSibling;

      if (targetUl && targetUl.tagName === 'UL') {
        targetUl.classList.toggle('is-open');
        this.classList.toggle('is-open');

        if (targetUl.classList.contains('is-open')) {
        } else {
        }
      }
    });
  });
});*/

document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.header-sidebar__linklist-button-child');

  buttons.forEach(button => {
    if (button.textContent.trim() === 'CATEGORY') {
      const targetUl = button.nextElementSibling;
      if (targetUl && targetUl.tagName === 'UL') {
        button.classList.add('is-open');
        targetUl.classList.add('is-open');
      }
    }

    button.addEventListener('click', function() {
      const targetUl = this.nextElementSibling;

      if (targetUl && targetUl.tagName === 'UL') {
        targetUl.classList.toggle('is-open');
        this.classList.toggle('is-open');
      }
    });
  });
});

// カート情報を取得して更新する関数
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElement = document.querySelector('.header__cart-dot-custom');
      if (cartCountElement) {
        cartCountElement.textContent = cart.item_count; // または cart.item_count
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

document.addEventListener('DOMContentLoaded', updateCartCount);


document.addEventListener("DOMContentLoaded", function () {
  const cartBtns = document.querySelectorAll(".sp_cart_btn, .favoorite_btn");
  const variationCart = document.querySelector(".variation_cart");
  const cartCloseBtn = document.querySelector(".variation_cart_close_btn");
  const closeBtn = document.querySelector(".variation_cart_close_innner_btn");
  const header = document.querySelector(".shopify-section--header");
  const body = document.querySelector("body");

  cartBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.add("active");
        cartCloseBtn.classList.add("active");
        header.classList.add("hidden");
        body.classList.add("pop");
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.remove("active");
        cartCloseBtn.classList.remove("active");
        header.classList.remove("hidden");
        body.classList.remove("pop");
      }
    });
  }

  if (cartCloseBtn) {
  cartCloseBtn.addEventListener("click", function () {
    if (variationCart) {
      variationCart.classList.remove("active");
      cartCloseBtn.classList.remove("active");
      header.classList.remove("hidden");
      body.classList.remove("pop");
    }
  });
}

/*
  cartCloseBtn.addEventListener("click", function () {
    if (variationCart) {
      variationCart.classList.remove("active");
      cartCloseBtn.classList.remove("active");
      header.classList.remove("hidden");
      body.classList.remove("pop");
    }
  });
  */
});


document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('.sp_button');
  const fixedBtn = document.querySelector('.sp_cart_btn_fixed');

  let isBelowTarget = false;

  if (!target || !fixedBtn) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        isBelowTarget = false;
        fixedBtn.classList.remove('active');
      } else {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > targetPosition) {
          isBelowTarget = true;
          fixedBtn.classList.add('active');
        }
      }
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(target);
});


document.addEventListener("DOMContentLoaded", function () {
  // .variation_cart内の.variant-blockにクリックイベントを追加
  const variationCart = document.querySelector('.variation_cart');
  if (variationCart) {
    const variantBlocks = variationCart.querySelectorAll('.variant-block');
    
    variantBlocks.forEach(block => {
      block.addEventListener('click', function() {
        try {
          // クリックされた要素のdata-color値を取得
          const colorValue = this.getAttribute('data-color');
          
          if (colorValue) {
            // .variant-picker__option要素の存在確認
            const variantPickerOption = document.querySelector('.variant-picker__option');
            
            if (variantPickerOption) {
              // 一致するdata-valueを持つ.thumbnail-swatchを探す
              const matchingSwatch = variantPickerOption.querySelector(
                '.thumbnail-swatch[data-value="' + colorValue + '"]'
              );
              
              if (matchingSwatch) {
                // 現在のスクロール位置を保存
                const currentScrollX = window.scrollX;
                const currentScrollY = window.scrollY;
                
                // 一致する要素を疑似的にクリック
                matchingSwatch.click();
                
                // スクロール位置を元に戻す
                window.scrollTo(currentScrollX, currentScrollY);
              }
            }
          }
        } catch (error) {
          // エラーが発生した場合はコンソールに出力（本番環境では削除可能）
          console.warn('variant-block click handler error:', error);
        }
      });
    });
  }
});


// document.addEventListener('DOMContentLoaded', function() {
//   // メディアクエリの定義 (PCのブレイクポイントに合わせる)
//   const mediaQuery = window.matchMedia('(min-width: 900px)');

//   function handleMediaQueryChange(e) {
//     if (e.matches) {
//       moveThumbnailSwatches();
//     }
//   }

//   // 要素を移動させる関数を定義
//   function moveThumbnailSwatches() {
//     // すべての thumbnail-swatch 要素を取得
//     const thumbnailSwatches = document.querySelectorAll('[id^="thumbnail-swatch--"]');

//     thumbnailSwatches.forEach(thumbnailSwatch => {
//       // thumbnail-swatch のIDから数字部分を抽出
//       const idParts = thumbnailSwatch.id.split('--');
//       if (idParts.length < 2) {
//         return; // IDの形式が不正な場合はスキップ
//       }
//       const commonId = idParts[1]; // 例: "51312956703009"

//       // 同じ数字部分を持つ variant__img 要素を検索
//       const targetVariantImg = document.getElementById(`variant__img--${commonId}`);

//       if (targetVariantImg) {
//         // thumbnailSwatch 要素を targetVariantImg の直後に移動
//         targetVariantImg.insertAdjacentElement('afterend', thumbnailSwatch);
//       }
//     });
//   }

//   // 初期ロード時にメディアクエリの状態をチェック
//   handleMediaQueryChange(mediaQuery);

//   // ウィンドウのリサイズ時にメディアクエリの状態が変更されたかを監視
//   mediaQuery.addEventListener('change', handleMediaQueryChange);
// });



// ScrollCarouselに最小限のアローボタンを追加
(function() {
  'use strict';

  function addArrowButtons() {
    const carousels = document.querySelectorAll('.product-gallery__image-list scroll-carousel:not([arrow-enhanced])');

    // 対象要素がない場合は処理を終了
    if (carousels.length === 0) {
      return;
    }
    
    carousels.forEach((carousel) => {
      // 処理済みマーク
      carousel.setAttribute('arrow-enhanced', '');
      
      // 親要素を相対位置に設定
      const parentElement = carousel.parentElement;
      if (getComputedStyle(parentElement).position === 'static') {
        parentElement.style.position = 'relative';
      }
      
      // アローボタンコンテナを作成
      const arrowContainer = document.createElement('div');
      arrowContainer.className = 'carousel-arrows';
      
      // 前のボタン
      const prevButton = document.createElement('button');
      prevButton.className = 'carousel-arrow carousel-arrow--prev';
      
      // 次のボタン
      const nextButton = document.createElement('button');
      nextButton.className = 'carousel-arrow carousel-arrow--next';
      
      // ボタンをコンテナに追加
      arrowContainer.appendChild(prevButton);
      arrowContainer.appendChild(nextButton);
      
      // コンテナをカルーセルの後に挿入
      carousel.insertAdjacentElement('afterend', arrowContainer);
      
      // クリックイベント
      prevButton.addEventListener('click', function() {
        if (typeof carousel.previous === 'function') {
          carousel.previous();
        } else {
          carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'smooth' });
        }
      });
      
      nextButton.addEventListener('click', function() {
        if (typeof carousel.next === 'function') {
          carousel.next();
        } else {
          carousel.scrollBy({ left: carousel.clientWidth, behavior: 'smooth' });
        }
      });
    });
  }

  // 実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addArrowButtons);
  } else {
    addArrowButtons();
  }
  
  // 遅延実行（カスタム要素の初期化を待つ）
  setTimeout(addArrowButtons, 1000);

})();


document.addEventListener('DOMContentLoaded', function() {
  const footerBtns = document.querySelectorAll('.footer_link__btn');

  function setupFooterAccordion() {
    if (window.innerWidth <= 991) {
      // スマホ時のみイベントリスナーを設定
      footerBtns.forEach(button => {
        // イベントリスナーが重複しないように、一度削除してから追加
        // (removeEventListenerは addEventListener と同じ関数参照が必要なので少し複雑になります)
        // 簡略化のため、ここでは直接設定しますが、SPAなどでは注意が必要です。
        // デバイスの向き変更などでリサイズが頻繁に起こる場合は、
        // isInitializedフラグなどを使って二重登録を防ぐロジックを追加するとより良いです。

        if (!button._isAccordionBound) { // カスタムプロパティでバインド済みかチェック
          button.addEventListener('click', handleButtonClick);
          button._isAccordionBound = true;
        }

        // スマホ時、activeクラスがなければULを非表示にする（初期状態）
        const targetUl = button.nextElementSibling;
        if (targetUl && targetUl.tagName === 'UL') {
          if (!button.classList.contains('active')) {
            targetUl.style.maxHeight = '0';
          } else {
            // activeな場合は展開
            targetUl.style.maxHeight = targetUl.scrollHeight + 'px';
          }
        }
      });
    } else {
      // PC時（991pxより大きい場合）はイベントリスナーを解除し、ULを常に表示状態にする
      footerBtns.forEach(button => {
        if (button._isAccordionBound) {
          button.removeEventListener('click', handleButtonClick);
          button._isAccordionBound = false;
        }
        button.classList.remove('active');
        const targetUl = button.nextElementSibling;
        if (targetUl && targetUl.tagName === 'UL') {
          targetUl.style.maxHeight = '1000px'; // CSSで設定した十分な高さと同じ値
          targetUl.style.overflow = 'visible'; // overflowも戻す
          targetUl.style.transition = 'none'; // アニメーションもなし
        }
      });
    }
  }

  function handleButtonClick() {
    const targetUl = this.nextElementSibling; // クリックされたボタンの次の要素
    if (targetUl && targetUl.tagName === 'UL') {
      this.classList.toggle('active'); // ボタンのクラスをトグル

      if (this.classList.contains('active')) {
        // 開く場合：scroll-height を設定
        targetUl.style.maxHeight = targetUl.scrollHeight + 'px';
      } else {
        // 閉じる場合：max-height を 0 に戻す
        targetUl.style.maxHeight = '0';
      }
    }
  }

  // ページ読み込み時に実行
  setupFooterAccordion();

  // ウィンドウのリサイズ時にも実行（デバウンス）
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupFooterAccordion, 250);
  });
});

// 例: theme.js または product.js など、テーマの主要なJSファイルに追加
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('product-form'); // または `<form>` 要素のセレクタ
  const deliveryTimeContainer = document.getElementById('ProductDeliveryTime');

  if (!productForm || !deliveryTimeContainer) {
    return; // 要素が見つからない場合は処理を終了
  }

  // Liquidから埋め込まれたバリエーションごとのメタフィールドデータを取得
  const allVariantsDeliveryTimeData = JSON.parse(document.getElementById('VariantDeliveryTimeData')?.textContent || '{}');

  // バリエーションが変更された時のイベントリスナー
  productForm.addEventListener('variant:change', function(event) {
    const selectedVariant = event.detail.variant; // 選択されたバリエーションオブジェクト

    if (selectedVariant && allVariantsDeliveryTimeData[selectedVariant.id]) {
      const variantData = allVariantsDeliveryTimeData[selectedVariant.id];
      const deliveryTime = variantData.delivery_time; // 'custom._time' の値を取得

      deliveryTimeContainer.innerHTML = ''; // 現在の表示をクリア

      if (deliveryTime && deliveryTime.trim() !== '') { // 値が存在し、空文字列でない場合
        deliveryTimeContainer.innerHTML = `<p>Pre Order: ${deliveryTime}</p>`;
      }
    }
  });
});

// 例: theme.js または product.js など、テーマの主要なJSファイルに追加
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('product-form'); // または `<form>` 要素のセレクタ
  const stockStatusContainer = document.getElementById('ProductStockStatus');

  if (!productForm || !stockStatusContainer) {
    return; // 要素が見つからない場合は処理を終了
  }

  // Liquidから全てのバリエーションのメタフィールド情報を含むデータをJSONで渡す
  // これは最も推奨される方法ですが、テーマのliquidファイルでの事前準備が必要です。
  // 例: <script type="application/json" id="AllVariantsData">
  //       {{ product.variants | map: 'id' | json }} // バリエーションIDのみ
  //       {% for variant in product.variants %}
  //         {% assign low_stock_data = variant.metafields.custom.low_stock | default: 0 %}
  //         {% assign variant_data_string = variant_data_string | append: variant.id | append: ':' | append: variant.inventory_quantity | append: ':' | append: low_stock_data | append: ',' %}
  //       {% endfor %}
  //       // 上記のように手動で文字列を構築するよりは、
  //       // product.variants と同様にカスタムデータ構造をJSONとして出力するのが良い
  // </script>

  // 代替案: 各バリエーションのIDとメタフィールド、在庫数をマップするJavaScriptオブジェクトを生成
  // Liquidファイル側で以下のスクリプトブロックを追加:
  /*
  <script type="application/json" id="VariantMetafieldData">
    {
      {% for variant in product.variants %}
        "{{ variant.id }}": {
          "inventory_quantity": {{ variant.inventory_quantity | default: 0 }},
          "low_stock_threshold": {{ variant.metafields.custom.low_stock | default: 0 }},
          "available": {{ variant.available | json }}
        }{% unless forloop.last %},{% endunless %}
      {% endfor %}
    }
  </script>
  */
  const allVariantsMetafieldData = JSON.parse(document.getElementById('VariantMetafieldData')?.textContent || '{}');


  // バリエーションが変更された時のイベントリスナー
  // Shopifyの標準的なテーマでは 'variant:change' イベントがよく使われます。
  // (旧テーマでは、formのchangeイベントをリッスンすることもあります)
  productForm.addEventListener('variant:change', function(event) {
    const selectedVariant = event.detail.variant; // 選択されたバリエーションオブジェクト

    if (selectedVariant && allVariantsMetafieldData[selectedVariant.id]) {
      const variantData = allVariantsMetafieldData[selectedVariant.id];
      const currentStock = variantData.inventory_quantity;
      const lowStockThreshold = variantData.low_stock_threshold;
      const isAvailable = variantData.available;

      let messageHtml = '';
      let messageClass = '';

      if (isAvailable) {
        if (lowStockThreshold !== 0 && currentStock <= lowStockThreshold) {
          if (currentStock > 0) {
            messageHtml = '<p>△ 残りわずか</p>';
            messageClass = 'stock-low';
          }
        } else if (currentStock > 0) { // low_stock_thresholdを超えているか、設定されていない場合
          messageHtml = '<p>◎ 在庫あり</p>';
          messageClass = 'stock-available';
        }
      } else {
        messageHtml = '<p>✗ 在庫切れ</p>';
        messageClass = 'stock-unavailable';
      }

      stockStatusContainer.innerHTML = messageHtml;
      stockStatusContainer.className = `product-page__stock-status ${messageClass}`; // クラスも更新
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.getElementById('StickyAddToCartBar');
  const stickyVariantSelect = document.getElementById('StickyVariantSelect');
  const stickyAddToCartButton = document.getElementById('StickyAddToCartButton');

  const mainAddToCartButton = document.querySelector('[name="add"]'); // メインのカートボタンのセレクタ
  const mainProductForm = document.querySelector('form[action="/cart/add"]'); // メインのフォームセレクタ


  let allVariantsData = [];
  try {
    const variantsDataScript = document.getElementById('StickyAllProductVariantsData');
    if (variantsDataScript) {
      allVariantsData = JSON.parse(variantsDataScript.textContent);
    }
  } catch (e) {
    console.error('Failed to parse StickyAllProductVariantsData:', e);
  }

  const mapScript = document.querySelector('script[id^="VariantTimeMap-"]');
  let variantTimeMap = {};
  try {
    if (mapScript) {
      variantTimeMap = JSON.parse(mapScript.textContent || '{}');
    }
  } catch (e) {
    console.error('Failed to parse VariantTimeMap:', e);
  }

  if (!stickyBar || !stickyAddToCartButton || allVariantsData.length === 0) {
    return;
  }

  // --- スクロール追従ロジックを修正 ---
  let isStickyBarVisible = false;
  // バーを表示するスクロールのしきい値。
  // このピクセル数スクロールしたら表示し始め、それ以降は基本的に隠さない。
  const displayThreshold = 300; 

  function toggleStickyBar() {
    const currentScrollY = window.scrollY;
    let shouldTriggerDisplay = false; // 表示を開始するトリガー

    if (mainAddToCartButton) {
      const rect = mainAddToCartButton.getBoundingClientRect();
      // メインボタンが画面外に出ているか (上か下に完全に隠れているか)
      const isMainButtonOffScreen = (rect.top > window.innerHeight || rect.bottom < 0);

      // メインボタンが画面外に出ていて、かつスクロール量がしきい値を超えている場合
      if (isMainButtonOffScreen && currentScrollY > displayThreshold) {
        shouldTriggerDisplay = true;
      }
    } else {
      // メインボタンが見つからない場合、純粋にスクロール量だけで判断
      if (currentScrollY > displayThreshold) {
        shouldTriggerDisplay = true;
      }
    }

    // 表示状態の切り替えロジック
    // 1. 表示トリガーが発動し、かつまだ表示されていない場合 -> 表示する
    if (shouldTriggerDisplay && !isStickyBarVisible) {
      stickyBar.classList.add('is-visible');
      isStickyBarVisible = true;
    } 
    // 2. スクロール量がしきい値を下回った場合、かつ現在表示されている場合 -> 非表示にする
    //    (これにより、ページの一番上近くに戻ったときのみ非表示になる)
    else if (currentScrollY <= displayThreshold && isStickyBarVisible) {
      stickyBar.classList.remove('is-visible');
      isStickyBarVisible = false;
    }
    // それ以外のケース（例: 一度表示された後、メインボタンが画面内に戻ってきたが、スクロール量はしきい値を超えている場合）
    // は、現在の isStickyBarVisible の状態を維持します。
  }

  // スクロールイベントリスナー
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(toggleStickyBar, 50); // パフォーマンスのためにデバウンス
  });
  // 初期ロード時にも実行
  toggleStickyBar();

  // --- バリエーション選択とボタン制御ロジック（変更なし） ---

  function updateStickyBar(selectedVariantId) {

const selectedVariant = allVariantsData.find(v => v.id === parseInt(selectedVariantId));
const isBeforeRelease = stickyAddToCartButton?.dataset.beforeRelease === 'true';
const releaseDateText = stickyAddToCartButton?.dataset.releaseDate; // 例: "01/01"

      if (selectedVariant) {
        if (isBeforeRelease) {
        stickyAddToCartButton.textContent = `${releaseDateText} Release`;
        stickyAddToCartButton.disabled = true;
        stickyAddToCartButton.classList.add('button--disabled');
      } else if (selectedVariant.available) {
        stickyAddToCartButton.textContent = 'カートに入れる';
        stickyAddToCartButton.disabled = false;
        stickyAddToCartButton.classList.remove('button--disabled');
      } else {
        stickyAddToCartButton.textContent = '在庫切れ';
        stickyAddToCartButton.disabled = true;
        stickyAddToCartButton.classList.add('button--disabled');
      }
    }
  }


  if (stickyVariantSelect) {
    stickyVariantSelect.addEventListener('change', function() {
      updateStickyBar(this.value);
    });
  }

  if (mainProductForm) {
    mainProductForm.addEventListener('variant:change', function(event) {
      const selectedVariant = event.detail.variant;
      if (selectedVariant && stickyVariantSelect) {
        stickyVariantSelect.value = selectedVariant.id;
      }
      updateStickyBar(selectedVariant.id);
    });

    stickyAddToCartButton.addEventListener('click', function() {
      if (this.disabled) return;

      const variantId = stickyVariantSelect ? parseInt(stickyVariantSelect.value) : allVariantsData[0].id;
      const quantity = 1;
      const reserveValue = variantTimeMap[variantId] || '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity,
            properties: {
              '予約': reserveValue
            }
          }]
        })
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorData => Promise.reject(errorData));
        }
        return response.json();
      })
      .then(data => {
        console.log('Added to cart:', data);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    });
  }

  if (stickyVariantSelect) {
    updateStickyBar(stickyVariantSelect.value);
  } else if (allVariantsData.length > 0) {
    updateStickyBar(allVariantsData[0].id);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // .cart-note .form-control > label に該当する全ての要素を取得
  const labels = document.querySelectorAll('.cart-note .form-control > label');

  // 各ラベルに対してクリックイベントリスナーを設定
  labels.forEach(label => {
    label.addEventListener('click', function() {
      // クリックされたlabelの次の兄弟要素がtextareaであるか確認
      const nextSibling = this.nextElementSibling; // 'this' はクリックされたlabel要素

      if (nextSibling && nextSibling.tagName === 'TEXTAREA') {
        // .open クラスがある場合は削除し、ない場合は追加する（トグル機能）
        nextSibling.classList.toggle('open');
        
        // オプション: クラスが付与された場合にのみフォーカスを当てる
        if (nextSibling.classList.contains('open')) {
          nextSibling.focus();
        }
      }
    });
  });
});


// collection SORT BYのクリックイベント無効化
document.querySelector('.collection-toolbar__button.sort_by')?.addEventListener('click', e => {
  e.preventDefault();
});


//top swiper スライダー
document.querySelectorAll('.swiper-custom').forEach((slider) => {
  const swiperInstance = new Swiper(slider, {
    slidesPerView: 1,
    loop: true,
    autoplay: true,
    //effect: 'fade',
    autoplayDisableOnInteraction: false,
		autoplay: 5000,
		speed: 1000,
    pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  });
});

// フィルターdrawerメニューをデフォルトで開いておく
document.addEventListener('DOMContentLoaded', function () {
  const targetTitles = ['PRICE', 'CATEGORY']; 

  document.querySelectorAll('accordion-disclosure').forEach((accordion) => {
    const summary = accordion.querySelector('summary');
    const labelSpan = summary?.querySelector('.text-with-icon');

    if (labelSpan && targetTitles.includes(labelSpan.textContent.trim().toUpperCase())) {
      const details = accordion.querySelector('details');
      if (details) {
        details.setAttribute('open', '');
        details.setAttribute('aria-expanded', 'true');
        // アニメーション制御用のstyle削除（必要なら）
        details.querySelector('.accordion__content')?.removeAttribute('style');
      }
    }
  });
});

/*

//fileter price　inputのmin/max値をリアルタイムで反映
document.addEventListener('DOMContentLoaded', function () {
    const minInput = document.getElementById('{{ filter.min_value.param_name }}');
    const maxInput = document.getElementById('{{ filter.max_value.param_name }}');
    const minDisplay = document.getElementById('min-price-display');
    const maxDisplay = document.getElementById('max-price-display');

    if (!minInput || !maxInput || !minDisplay || !maxDisplay) {
      console.log('Price inputs or display elements not found');
      return;
    }

    const formatNumber = (num) => {
      return num.toLocaleString();
    };

    const updateDisplay = (input, display) => {
      input.addEventListener('input', function () {
        let raw = this.value.replace(/,/g, '').replace(/[^\d]/g, '');
        if (raw === '') {
          display.textContent = '-';
          return;
        }
        display.textContent = formatNumber(Number(raw));
      });

      // 初期表示
      let initialRaw = input.value.replace(/,/g, '').replace(/[^\d]/g, '');
      display.textContent = initialRaw ? formatNumber(Number(initialRaw)) : '-';
    };

    updateDisplay(minInput, minDisplay);
    updateDisplay(maxInput, maxDisplay);
  });

 */

// 
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('product-form');
  const hiddenReserveInput = document.getElementById('js-delivery-flag-input');

  if (!productForm || !hiddenReserveInput) {
    console.warn('必要な要素が見つかりません。セレクターを確認してください。');
    return;
  }

  const allVariantsData = JSON.parse(document.getElementById('VariantDeliveryTime')?.textContent || '{}');
  
  productForm.addEventListener('variant:change', function(event) {
    const selectedVariant = event.detail.variant;
    
    if (selectedVariant && allVariantsData[selectedVariant.id]) {
      const variantData = allVariantsData[selectedVariant.id];
      let deliveryFlagValue = '';

      if (variantData.delivery_flag) {
        // 先頭の "[ と末尾の ] を取り除く
        let cleanValue = variantData.delivery_flag.replace(/^\[|\]$/g, '');
        // 文字列の先頭と末尾の &quot; を取り除く
        cleanValue = cleanValue.replace(/^&quot;|&quot;$/g, '');
        
        deliveryFlagValue = cleanValue;
      }

      hiddenReserveInput.value = deliveryFlagValue;
      console.log('更新された予約フラグ:', hiddenReserveInput.value);
    }
  });
});
